import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { SearchProject_MF } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';


@Component({
  selector: 'app-maintainance-fee',
  templateUrl: './maintainance-fee.component.html',
  styleUrls: ['./maintainance-fee.component.css']
})
export class MaintainanceFeeComponent implements OnInit {
title="Maintainance Fee";
title1="";
title2="";
sp: SearchProject_MF;
SearchResult:any={};

  constructor(private userService: UserService, private errorHandler: ErrorHandler, private router: Router) {
    this.sp = new SearchProject_MF();

   }

  ngOnInit() {
  }


  SearchProject(sp) {
    //alert(this.sp.app_no); 
    //alert(this.sp.property_no); 
    var App_No = 'empty'; 
    var Property_No = 'empty'; 
    //this.isApp = false;
    if (this.sp.app_no == null || this.sp.app_no == '')
    { 
        swal('warning!', 'Please enter the application no.', 'warning');
        document.getElementById('loader-spinner').style.display = "none";          
        return;     
    }
    else {
      App_No = this.sp.app_no.trim();      
    }
    
    if (this.sp.property_no == null || this.sp.property_no == '') 
    { 
        swal('warning!', 'Please enter the property no.', 'warning');
        document.getElementById('loader-spinner').style.display = "none";
        return;      
    }
    else {
      Property_No = this.sp.property_no.trim();
    }

    this.userService.GetProjectDetail_MF(App_No, Property_No)
    .subscribe(
      (data: any) => {
        
        document.getElementById('loader-spinner').style.display = "none";
        this.SearchResult = data;
        //console.log(this.SearchResult);        
        
      }, (error) => {       
        if (error.status == 404) {         
          swal('warning!', 'No data found.', 'warning');
          this.SearchResult.Project_Name='';
          this.SearchResult.District_Name='';
          this.SearchResult.Phase_Name='';
          this.SearchResult.Scheme_Name='';
        }
        
      });
    
  }

  payment(){
    swal({
      //title: '<i>HTML</i> <u>example</u>',
      //type: 'info',
      html:
        '<input placeholder="Mode of Payment" type="text" class="form-control"><br>' +
        '<input placeholder="Date" type="date" class="form-control"><br>' +
        '<input placeholder="Amount" type="text" class="form-control"><br>' +
        '<input placeholder="Name" type="text" class="form-control"><br>' ,
      
        
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        'Save',    
      cancelButtonText:
      'Cancel',
    })
  }
  
}



// WEBPACK FOOTER //
// ./src/app/allocation/maintainance-fee/maintainance-fee.component.ts